// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"693":"2e421c3f0285f19a","888":"6cdfaf4898b13821"}[chunkId] + ".css";
};